const searchCache: Record<string, Record<string, boolean>> = {}

/**
 * Searches in the given `content` string for the given `terms`
 */
export const search = (content: string, terms: readonly string[]): boolean => {
    for (let i = 0; i < terms.length; i++) {
        const term = terms[i]!

        const hit = searchCache[term]?.[content]

        const wasHit = hit !== undefined

        const matches = wasHit ? hit : content.includes(term)

        if (!wasHit) {
            searchCache[term] = { ...searchCache[term], [content]: matches }
        }

        if (matches) {
            return true
        }
    }

    return false
}
